import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

const useForceUpdateTranslation = () => {
    const { i18n } = useTranslation();
    const [, setLanguage] = useState(i18n.language); // 상태 변경 감지용

    useEffect(() => {
        const handleLanguageChange = (lng) => {
            setLanguage(lng); // 상태 변경하여 강제 리렌더링
        };

        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    return useTranslation(); // 항상 최신 `t()`를 가져옴
};

export default useForceUpdateTranslation;